/**
 * Do not edit directly
 * Generated on Fri, 25 Nov 2022 14:07:59 GMT
 */
export var base = "0px 1px 2px 0px #0000000f, 0px 1px 3px 0px #0000001a";
export var sm = "0px 1px 2px 0px #0000000d";
export var md = "0px 2px 4px -1px #0000000f, 0px 4px 6px -1px #0000001a";
export var lg = "0px 4px 6px -2px #0000000d, 0px 10px 15px -3px #0000001a";
export var xl = "0px 10px 10px -5px #0000000a, 0px 20px 25px -5px #0000001a";
export var xxl = "0px 25px 50px -12px #00000040";
//# sourceMappingURL=shadows.js.map